import { Component } from '@angular/core';

import { environment } from '../environments/environment'
import { Platform, MenuController, AlertController, LoadingController, ModalController } from '@ionic/angular';
import { NavigationEnd, Router } from '@angular/router';
import { AppViewModel } from 'src/app/AppViewModel';
import { BasePage } from 'src/pages/base.page';
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { DrawerMenuModel } from 'projects/core/src/lib/core/model/DrawerMenuModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { HelperMenuContrato } from 'projects/core/src/lib/core/HelperMenuContrato';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { ContratoMenuModel } from 'projects/core/src/lib/core/model/ContratoMenuModel';
import { RoutingState } from './RoutingState';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { MessageService } from 'projects/core/src/lib/core/MessageService';
import { PlanoDialog } from 'src/pages/plano/plano.dialog';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';

import { PushNotifications } from '@capacitor/push-notifications';
import { Style, StatusBar } from '@capacitor/status-bar';
import { Share } from '@capacitor/share';

import { FCM } from '@capacitor-community/fcm';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { CustomApplication } from './CustomApplication';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
const fcm = FCM;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent extends BasePage implements NavegaTelaPlanoImpl {

  appViewModel: AppViewModel
  usuario: UsuarioModel = new UsuarioModel()
  contratoWrapper: ContratoWrapperModel
  loadingComponent: LoadingComponent
  nomeVersao = `Versão ${environment.versionName}`
  routingState: RoutingState
  ambienteDesenvolvimento: boolean = false

  constructor(
    private platform: Platform,
    public router: Router,
    private menu: MenuController,
    private googleAnalyticsService: GoogleAnalyticsService,
    public alertController: AlertController,
    private loadingController: LoadingController,
    private modalCtrl: ModalController) {
    super(router)
    this.initializeApp();
    CustomApplication.instanceModalCtrl = this.modalCtrl
    CustomApplication.instanceRoute = this.router
    CustomApplication.instanceAlertCtrl = this.alertController
  }

  drawerMenu: Array<DrawerMenuModel>
  alertComponent: AlertComponent
  token: String

  async ngOnInit() {
    this.iniciaVariaveis();
    this.routingState.loadRouting();
    this.verificaAmbienteDesenvolvimento();
    this.initObservable()
  }

  async iniciaVariaveis() {
    this.appViewModel = new AppViewModel()
    this.appViewModel.setContext(this)
    this.setInformacoesUsuario()
    this.loadingComponent = new LoadingComponent(this.loadingController)
    this.routingState = new RoutingState(this.router)
  }

  checkPlatformIsIos() {
    return this.platform.is("ios")
  }

  initObservable() {
    MessageService.getMessage().subscribe(async message => {
      if (message && message.identifyObservable == MessageService.KEY_LOGIN) {
        this.setInformacoesUsuario()
      } else if (message && message.identifyObservable == MessageService.KEY_LOGOUT_FOR_INVALID_TOKEN) {
        const isWeb = await AppStorage.get(AppSession.CHAVE_IS_WEB)
        if (isWeb == true) {
          this.openPage("error-generic")
        } else {
          this.sair()
        }
        
      } else if (message && message.identifyObservable == MessageService.KEY_REDIRECT_BY_REFRESH_TOKEN) {
        this.openPage("/")
      }
    })
  }

  async setInformacoesUsuario() {
    const usuarioLogado = await this.appViewModel.obtemUsuarioLogado()
    if (usuarioLogado) {
      this.buscaDrawerMenu()
      this.usuario = usuarioLogado;
      const tokenFirebase = await fcm.getToken()
      this.appViewModel.salvaTokenApi(tokenFirebase.token)
    }
  }

  async buscaContratos() {
    await this.appViewModel.buscaContratos()
  }

  async compartilhar() {
    await Share.share({
      text: `O aplicativo perfeito para você investir com segurança, rentabilidade e simplicidade.  Baixe o app PhiCube Mobile!\n\nPara Android: ${environment.urlAppAndroid}\nPara iOS: ${environment.urlAppIos}`
    })
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  showAlert(title: string, message: string) {
    AlertComponent.showAlert(title, message)
  }

  async buscaDrawerMenu() {
    await this.appViewModel.obtemDrawerMenu()
  }

  async clickItemMenu(item: DrawerMenuModel) {
    this.fecharMenu()
    try {
      this.googleAnalyticsService
        .logEvent(`acesso_${item.title}`, {
          acesso_de: 'sidemenu'
        })

      if (item.nivelRestricao == ContratoMenuModel.NIVEL_RESTRICAO_ALTO) {
        await this.buscaContratos()
        if (await HelperMenuContrato.validaMenu(item)) {
          this.openPage(item.page)
        }
      } else {
        // TODO: REFATORAR PARA CHECAR O TIPO DA AÇÃO (REDIRECT/POPUP)
        if (item.chaveContrato) {
          if (item.chaveContrato.indexOf(ChaveContratoEnum.CONTRATO_INDICAR_APP) >= 0) {
            this.compartilhar()
            return
          }
        }
        this.openPage(item.page)
      }
    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, e.message)
    }
  }

  async navegaTelaPlano(urlContratar) {
    const modalBoasVindas = await this.modalCtrl.create({
      component: PlanoDialog,
      componentProps: {
        urlContratar
      }
    });
    modalBoasVindas.present();
  }

  fecharMenu() {
    this.menu.close();
  }

  sair() {
    AppSession.clearSession()
    this.fecharMenu()
    // this.openPage('onboarding')
    this.openPage('login')
  }

  setDrawerMenu(menu: Array<DrawerMenuModel>) {
    this.drawerMenu = menu
  }

  async initializeApp() {
    const _self = this
    this.platform.ready().then(() => {
      if (this.platform.is("ios")) {
        _self.router.events.subscribe((val) => {
          // see also 
          if (val instanceof NavigationEnd) {
            if (val.url.indexOf("/navigation/analise-ativos") >= 0 ||
              val.url.indexOf("/navigation/prisma") >= 0) {
              StatusBar.setStyle({
                style: Style.Light
              });
            } else {
              StatusBar.setStyle({
                style: Style.Dark
              });
            }
          }
        });
      }

      StatusBar.setStyle({
        style: Style.Dark
      });

      StatusBar.setOverlaysWebView({
        overlay: false
      });

      StatusBar.setBackgroundColor({
        color: '#1846bb',
      })

      this.checaPermissaoNotificacao()
    });
  }

  async checaPermissaoNotificacao() {
    PushNotifications.requestPermissions()
  }

  setListaContratos(contratoWrapper: ContratoWrapperModel) {
    this.contratoWrapper = contratoWrapper
  }

  verificaAmbienteDesenvolvimento() {
    this.ambienteDesenvolvimento = !environment.production
  }
}
